export { globalStyles } from './global'
